import classNames from 'classnames';

import styles from './Chevron.module.scss';

const ROTATION_MAP = {
  left: 0,
  right: 180,
  up: 90,
  down: 270,
};

type Props = {
  direction: 'left' | 'right' | 'up' | 'down';
  color?: string;
  className?: string;
};
export default function Chevron({ direction, color, className }: Props) {
  return (
    <svg
      className={classNames(styles.chevron, className)}
      fill="none"
      height="38"
      style={{ transform: `rotate(${ROTATION_MAP[direction]}deg)` }}
      viewBox="0 0 22 38"
      width="22"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.8485 3.57914e-06C19.1756 -0.000251977 19.4995 0.0642927 19.8014 0.189915C20.1034 0.315536 20.3773 0.49974 20.6077 0.731888C21.0743 1.20167 21.3363 1.83698 21.3363 2.49915C21.3363 3.16131 21.0743 3.79662 20.6077 4.2664L6.04392 18.8962L20.8142 33.733C21.281 34.2028 21.543 34.8382 21.543 35.5005C21.543 36.1628 21.281 36.7982 20.8142 37.268C20.5836 37.5 20.3095 37.684 20.0076 37.8097C19.7056 37.9353 19.3817 38 19.0547 38C18.7276 38 18.4038 37.9353 18.1018 37.8097C17.7999 37.684 17.5257 37.5 17.2952 37.268L0.765159 20.6635C0.29862 20.1936 0.0367505 19.5583 0.0367506 18.8962C0.0367506 18.2341 0.29862 17.5988 0.76516 17.1289L17.0888 0.731399C17.3192 0.49926 17.5934 0.31509 17.8954 0.189548C18.1975 0.0640103 18.5214 -0.000412251 18.8485 3.57914e-06Z"
        fill={color ?? '#FFF'}
      />
    </svg>
  );
}
